export const EXPERIENCE_RANGE_KEYS = ['1-5', '5-10', '10-20', '20+'] as const;

export type ExperienceRangeKey = (typeof EXPERIENCE_RANGE_KEYS)[number];

export type ExperienceRange = {
  key: ExperienceRangeKey;
  label: string;
  min: number;
  max: number | null;
};

export const EXPERIENCE_RANGES: readonly ExperienceRange[] = [
  { key: '1-5', label: '1–5 years', min: 1, max: 5 },
  { key: '5-10', label: '5–10 years', min: 5, max: 10 },
  { key: '10-20', label: '10–20 years', min: 10, max: 20 },
  { key: '20+', label: '20+ years', min: 20, max: null },
];
